export default __webpack_public_path__ + "static/media/1.ad84bf12.png";